import { Box, SimpleGrid } from "@chakra-ui/layout"
import React from "reactn"
import { ColumnCard } from "./column-card"

export function ColumnListing({ eager, columns = [] }) {
  return (
    <Box marginLeft={[0,0,0,0]} marginRight={[0,0,0,0]}>
      <SimpleGrid id="columnsListing" columns={[1, 1, 2, 2]} spacing={"20px"}>
      {columns.map((c, i) => (
        <Box key={`cl${i}`}>
          <ColumnCard  columnCard={c}  eager={eager} eagerxxx={i === 0} />
        </Box>
      ))}
    </SimpleGrid>
    </Box>
  )
}
